module.exports = __webpack_public_path__ + "img/home23w.48741eed.jpg";